import * as yup from 'yup';
import 'yup-phone';

const walletSchema = yup.object().shape({
  wallet: yup.string().required('Mandatory wallet field!')
});
export { walletSchema };
